const DefaultDashboard = () => {
  return (
    <>
      <div></div>
    </>
  );
};

export default DefaultDashboard;
